/**
 * O estado vazio do padrão (DESIGN.md, "Estado vazio"): um ícone num círculo apagado, uma frase, a
 * explicação e as ações. O mesmo em todas as telas, sem moldura tracejada.
 */
import type { ReactNode } from 'react';
import { Icon, type IconName } from './icons.js';

export function EmptyState({ icon, title, text, children, className }: { icon: IconName; title: ReactNode; text?: ReactNode; children?: ReactNode; className?: string }) {
  return (
    <div className={`rd-emptyState${className ? ` ${className}` : ''}`}>
      <span className="rd-emptyState__icon" aria-hidden="true">
        <Icon name={icon} size={22} />
      </span>
      <p className="rd-emptyState__title">{title}</p>
      {text ? <p className="rd-emptyState__text">{text}</p> : null}
      {children ? <div className="rd-emptyState__actions">{children}</div> : null}
    </div>
  );
}
